<template>
  <div>
    <!-- Main content -->
    <section class="content">   
      <div class="row">
        <div class="col-md-12">
          <div><button type="button" class="btn btn-primary" style="margin-bottom:10px" @click="openFolderModel('create')">Create Folder</button></div>
          <div class="box box-default margin-bottom-0px query-list-table-wrapper">
            <vue-good-table
              styleClass="vgt-table good-table condensed striped"                    
              :columns="columns"
              :rows="folderData"
              :pagination-options="{
                  enabled: true,
                  perPage: 20
              }"
              :sort-options="{
                      enabled: true,
                      initialSortBy: {field: 'createdAt', type: 'desc'}
                    }"
              >
              <div slot="emptystate"><nv-empty-state icon="fa-folder-o" title="No folders yet" hint="Create a folder to group your audience queries." /></div>
                <template slot="loadingContent">
                  <!-- Empty loading screen to disable default loading -->
                </template>
                <template slot="table-row" slot-scope="props">
                  <slot :props="props" />

                  <span v-if="props.column.field == 'createdAt'">
                    {{formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')}}
                  </span>
                  <span v-else-if="props.column.field == 'updatedAt'">
                    {{formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')}}
                  </span>
                  <span v-else-if="props.column.field == 'edit'">
                    <i class="fa fa-pencil" aria-hidden="true" @click="openFolderModel('rename', props.row.id,  props.row.folderName,  props.row.isActive)"></i>
                  </span>
                  <span v-else>{{props.formattedRow[props.column.field]}}</span>
                </template>    
            </vue-good-table>
          </div>
        </div>
      </div>
    </section>
    <div class="modal-backdrop" v-if="showCreateFolderModel" id="CreateAudienceFolder">
      <div class="modal modal-md" style="height: 230PX;max-width:600px">
        <header class="modal-header">
          <slot name="header">
            <h3>Create Folder</h3>
          </slot>
          <div class="modal-body">
            <slot name="body">
            <div class="form-horizontal">
              <div class="form-group">
                <label for="newFolderName" style="font-weight:500;text-align:left" class="col-sm-4 control-label required">Folder Name</label>
                <div class="col-sm-8" style="text-align: left;">
                  <input type="text" class="form-control" v-model="newFolderName"/>
                  <span v-if="submittedFolderName && !$v.newFolderName.required" class="text-red pull-right">Please enter a folder name.</span>
                </div>
              </div>
              <div class="form-group pull-right" style="margin-right:3px;margin-top:20px;">
                <div class="col-sm-12">
                  <button type="button" class="btn btn-primary" @click="closeFolderModel('create')">Cancel</button>
                  <button type="button" class="btn btn-primary" @click="createFolder">Submit</button>
                </div>
              </div>
            </div>
            </slot>
          </div>
        </header>
        <footer class="modal-footer"></footer>
      </div>
    </div>
    <div class="modal-backdrop" v-if="showRenameFolderModel" id="RenameAudienceFolder">
      <div class="modal modal-md" style="height: 230PX;max-width:600px">
        <header class="modal-header">
          <slot name="header">
            <h3>Rename Folder</h3>
          </slot>
          <div class="modal-body">
            <slot name="body">
            <div class="form-horizontal">
              <div class="form-group">
                <label for="folderName" style="font-weight:500;text-align:left" class="col-sm-4 control-label required">Folder Name</label>
                <div class="col-sm-8" style="text-align: left;">
                  <input type="text" class="form-control" v-model="folderName"/>
                  <span v-if="submittedFolderName && !$v.folderName.required" class="text-red pull-right">Please enter a folder name.</span>
                </div>
              </div>
              <div class="form-group pull-right" style="margin-right:3px;margin-top:20px;">
                <div class="col-sm-12">
                  <button type="button" class="btn btn-primary" @click="closeFolderModel('rename')">Cancel</button>
                  <button type="button" class="btn btn-primary" @click="renameFolder">Submit</button>
                </div>
              </div>
            </div>
            </slot>
          </div>
        </header>
        <footer class="modal-footer"></footer>
      </div>
    </div>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>   
  </div>  
  
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import * as helpers from './helpers'
import api from '../../../../utils/api'
import { formatDate } from '../../../../utils/utilities'
import moment from 'moment'
import flatPickr from 'flatpickr'

export default {
  name: 'folderTable',
  validations: {
    folderName: { required },
    newFolderName: { required }
  },
  components: {
    flatPickr
  },
  async mounted () {
    this.loading = true
    await this.fetchFolders()
    flatPickr('input[placeholder="Select Date Range', {
      dateFormat: 'd-m-Y',
      mode: 'range',
      allowInput: true
    })
  },
  data () {
    return {
      formatDate: formatDate,
      loading: false,
      folderData: [],
      showCreateFolderModel: false,
      showRenameFolderModel: false,
      submittedFolderName: false,
      newFolderName: '',
      folderName: '',
      folderId: undefined,
      columns: [
        {
          label: 'Folder Name',
          sortable: true,
          field: 'folderName',
          filterable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Search Folder Name'
          }
        },
        {
          label: 'Created On',
          sortable: true,
          field: 'createdAt',
          filterable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Select Date Range',
            filterFn: this.dateRangeFilter
          }
        },
        {
          label: 'Updated On',
          sortable: true,
          field: 'updatedAt',
          filterable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Select Date Range',
            filterFn: this.dateRangeFilter
          }
        },
        {
          label: 'Edit',
          sortable: false,
          field: 'edit'
        }
      ]
    }
  },
  methods: {
    dateRangeFilter (data, filterString) {
      let dateRange = filterString.split('to ')
      let startDate = moment(dateRange[0], 'DD-MM-YYYY').unix() * 1000
      let endDate = moment(dateRange[1] || dateRange[0], 'DD-MM-YYYY').add(1, 'days').unix() * 1000
      return (data = Date.parse(data) >= startDate && Date.parse(data) <= endDate)
    },
    closeFolderModel (action) {
      if (action === 'create') {
        this.showCreateFolderModel = false
      } else if (action === 'rename') {
        this.showRenameFolderModel = false
      }
      this.submittedFolderName = false
      this.folderId = ''
      this.folderName = ''
      this.newFolderName = ''
      // this.isFolderActive = false
    },

    openFolderModel (action, folderId, folderName) {
      if (action === 'create') {
        this.showCreateFolderModel = true
      } else {
        this.showRenameFolderModel = true
        this.folderId = folderId
        this.folderName = folderName
      }
    },

    async fetchFolders () {
      this.loading = true
      try {
        const response = await api.buildRequest(`/audience/getAllFolders`, 'POST')
        const formattedData = helpers.formatFolderRawData(response.data.payload)
        this.folderData = formattedData.map(folder => { return folder })
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$swal({
          title: 'Failure',
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },

    async createFolder () {
      this.submittedFolderName = true
      this.$v.newFolderName.$touch()
      if (this.$v.newFolderName.$invalid) {
        return
      }
      this.showCreateFolderModel = false
      this.loading = true
      try {
        const response = await api.buildRequest(`/audience/createFolder`, 'POST', {
          folderName: this.newFolderName
        })
        this.$swal({
          title: response.status === 200 ? 'Success' : 'Failure',
          type: response.status === 200 ? 'success' : 'error',
          text: response.data.payload.message
        })
        this.fetchFolders()
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$swal({
          title: 'Failure',
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },

    async renameFolder () {
      this.submittedFolderName = true
      this.$v.folderName.$touch()
      if (this.$v.folderName.$invalid) {
        return
      }
      this.showRenameFolderModel = false
      this.loading = true
      try {
        const response = await api.buildRequest(`/audience/updateFolder`, 'POST', {
          folderName: this.folderName,
          folderId: this.folderId
        })
        this.$swal({
          title: response.status === 200 ? 'Success' : 'Failure',
          type: response.status === 200 ? 'success' : 'error',
          text: response.data.payload.message
        })
        this.fetchFolders()
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$swal({
          title: 'Failure',
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    }
  }
}
</script>
<style>
.query-list-table-wrapper {
  min-height: 600px;
}
</style>


// WEBPACK FOOTER //
// folderTable.vue?84ffa244